import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/authContext/authContext";

export const PublicRoute = ({ children }) => {
  const { user } = useContext(AuthContext);
  return user.name ? <Navigate to="/cargar-archivos" /> : children;
};
